import React, { useState } from 'react';
import { HelpCircle, Camera, CheckCircle, XCircle } from 'lucide-react';
import { cn } from '../utils/cn';

interface PhotoHelpTooltipProps {
  onOpenFullManual: () => void;
  darkMode?: boolean;
}

export const PhotoHelpTooltip: React.FC<PhotoHelpTooltipProps> = ({ onOpenFullManual, darkMode = true }) => {
  const [isOpen, setIsOpen] = useState(false);

  const condensedGuidelines = [
    { icon: CheckCircle, text: 'Fundo neutro (parede branca/clara)', type: 'do' as const },
    { icon: CheckCircle, text: 'Boa iluminação (luz natural)', type: 'do' as const },
    { icon: CheckCircle, text: 'Rosto centralizado e visível', type: 'do' as const },
    { icon: CheckCircle, text: 'Expressão neutra (não sorrir)', type: 'do' as const },
    { icon: XCircle, text: 'SEM óculos (grau ou sol)', type: 'dont' as const },
    { icon: XCircle, text: 'SEM boné, máscara ou fones', type: 'dont' as const },
    { icon: CheckCircle, text: 'Distância: 50cm-1m', type: 'do' as const },
  ];

  return (
    <div className="relative">
      {/* Help Icon Button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="p-1.5 rounded-full hover:bg-gray-800 transition-colors"
        aria-label="Ver dicas para foto"
        type="button"
      >
        <HelpCircle className="h-5 w-5 text-blue-400" />
      </button>

      {/* Popover */}
      {isOpen && (
        <>
          {/* Backdrop */}
          <div className="fixed inset-0 z-40" onClick={() => setIsOpen(false)} />

          {/* Tooltip Content */}
          <div className="absolute top-full right-0 mt-2 w-80 bg-gray-900 border border-gray-700 rounded-lg shadow-2xl z-50 overflow-hidden">
            {/* Header */}
            <div className="flex items-center gap-2 px-4 py-3 bg-gray-800 border-b border-gray-700">
              <Camera className="h-4 w-4 text-blue-400" />
              <p className="text-sm font-semibold text-white">Dicas para Foto</p>
            </div>

            {/* Guidelines List */}
            <div className="p-3 space-y-2">
              {condensedGuidelines.map((guideline, index) => (
                <div key={index} className="flex items-start gap-2">
                  <guideline.icon
                    className={cn(
                      "h-4 w-4 flex-shrink-0 mt-0.5",
                      guideline.type === 'do' ? "text-green-400" : "text-red-400"
                    )}
                  />
                  <p className="text-xs text-gray-300">{guideline.text}</p>
                </div>
              ))}
            </div>

            {/* Full Manual Link */}
            <button
              onClick={() => {
                setIsOpen(false);
                onOpenFullManual();
              }}
              className="w-full px-4 py-2 bg-blue-500/10 hover:bg-blue-500/20 border-t border-gray-700 text-sm text-blue-400 transition-colors text-center"
              type="button"
            >
              Ver manual completo →
            </button>
          </div>
        </>
      )}
    </div>
  );
};
